import React from 'react';
import { Product } from '../models/product';
import { Country } from '../models/country';
import { SearchResult } from '../models/search';
import { CartItem, WishlistItem } from '../models/cart';
import { HomepageProps } from './homepageProps';
import { CategoryTree } from '../shared/helpers/categoryTree';

type CartProps = {
  cartItems: CartItem[];
  fbCartData: {
    content_ids: string[];
    content_type: 'product';
    currency: string;
    value: string;
  };
  wishlistItems: WishlistItem[];
};

export type ProductDetailsPageProps = {
  adrollCustomData: {
    product_group: string;
  };
  canEdit: boolean;
  exclusions: string[];
  isCountryDDP: boolean;
  product: Product;
  relatedProducts: SearchResult[];
  twitter: {
    title: string;
  };
  userFacingDepartment: string;
};

type MenuChildren = {
  children: MenuChildren[];
  featuredDesigners: string[];
  name: string;
  url: string;
};

type MadeInCountry = {
  country: string;
  isoCode: string;
};

export type ContextProps = {
  approxCurrencyCode: string;
  billingCurrencyCode: string;
  brandName: string;
  cartPage?: CartProps;
  categories?: any[];
  categoryTree?: CategoryTree[];
  countries: Country[];
  countriesForSeo: Country[];
  country: string;
  countryCode: string;
  countryId: string;
  countryIso: string;
  currencySymbol: string;
  department: string;
  departments?: any[];
  devicePixelRatio: string;
  email: string;
  euCookiePolicyAccepted: boolean;
  fbOptions: {
    debug: boolean;
  };
  footerData: any[];
  freeShipping: boolean;
  hasAdminArea: boolean;
  homepage?: HomepageProps;
  initialOptionsData?: any;
  isAdmin: boolean;
  isEu: boolean;
  location: {
    hostname: string;
    originalUrl: string;
    path: string;
    query: Record<string, string | string[] | boolean[]>;
  };
  madeInCountries: MadeInCountry[];
  menu: { menu: MenuChildren[] };
  metadata?: {
    description?: string;
    title?: string;
  };
  noindex?: boolean;
  numCartItems: number;
  overridingCanonicalUrl?: string;
  page: string;
  paths: {
    account: string;
    admin: string;
    secure: string;
    web: string;
  };
  productDetails?: ProductDetailsPageProps;
  recaptchaKey: string;
  runAdroll: boolean;
  s3BasePath: string;
  scripts: {
    riskifiedDomain: string;
    riskifiedSessionId: string;
  };
  searchMode?: {
    designersMode: boolean;
    productsMode: boolean;
    storesMode: boolean;
  };
  userAgent: string;
  userId: string;
};

export const AppContext = React.createContext<Partial<ContextProps>>({});
export const useAppContext = () => React.useContext(AppContext);
